export default __webpack_public_path__ + "static/media/Nefarious Chest.249725e3.jpg";